import React from 'react';
import { Modal } from 'react-bootstrap';
import { selectLoader } from '../utils/Helpers';
import {CROSS_ICON} from '../pages/projects/kanban/assets/image';

const ConfirmModal = ({
  show,
  onHide,
  handleAction,
  confirmationText,
  loading,
  closeText,
  isRecurring = false,
  handleNo,
  bgClassname,
  showNoButton = true
}) => {
  return (
    <div className="confirm-modal-wrapper" onClick={(e) => e.stopPropagation()}>
      <Modal show={show} onHide={onHide} dialogClassName="" centered className={`deletModal ${bgClassname}`}>
        {/* <Modal.Header closeButton={true}>
        </Modal.Header> */}
        <div className='confirm-cross' onClick={onHide}><img src={CROSS_ICON} alt="close-icon" /></div>
        <Modal.Body>{confirmationText}</Modal.Body>
        <Modal.Footer>
          {showNoButton && (
            <button onClick={isRecurring ? handleNo : onHide} className="cancel-btn " disabled={loading}>
              {isRecurring ? (!loading ? 'Recurrence date' : selectLoader(25,0)) : 'No'}
            </button>
          )}
          <button
            onClick={handleAction}
            className="delet-btn"
            style={{ padding: !loading ? '' : '0' }}
            disabled={loading}>
            {!loading ? (isRecurring ? 'Today' : closeText) : selectLoader(25,0)}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
